import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

$('.js-team-to').on('click', function(e){
    var link = $(this).attr('href');
    var $section = $(link);
    var scrollTo = $section.offset().top - $('.header').height() - 120;
    gsap.to(window, {
        duration: 2,
        scrollTo: scrollTo,
        ease: 'Expo.easeOut'
    });
    e.preventDefault();
});
